import React, { useState } from 'react'
import { TemplateSanarContext } from './context'
import { useScreenMeasure } from './hooks'

export const SanarProvider = (props) => {
  const [isShowLoading, setIsShowLoading] = useState(false)
  const [email, setEmail] = useState()
  const [isMobile] = useScreenMeasure()
  const [revalidateOtp, setRevalidateOtp] = useState(false)

  const value = {
    isMobile,
    isShowLoading,
    setIsShowLoading,
    email,
    setEmail,
    revalidateOtp,
    setRevalidateOtp,
  }

  return <TemplateSanarContext.Provider value={value}>{props.children}</TemplateSanarContext.Provider>
}
